import { Button } from "Components/Button";
import { Cart } from "Pages/PreBudgetConvertionUnit/styles";
import { Box } from "styles/globalComponents";

import { FormikProvider } from "formik";
import { Modal } from "Components/Modals/Modal";
import Attention from "Assets/Images/atention.svg";
import { InfoDetails } from "./InfoDetails";
import { CartSummary } from "./CartDetails/CartSummary";

import { useCartDetails } from "../../hooks/useCartDetails";

export const CartDetails = () => {
  const {
    formik,
    setTab,
    tab,
    blockUserInteraction,
    items,
    handleCancelPreBudget,
    handleSubmit,
    loading,
    cancelModal,
    setCancelModal,
    onCancelBudget,
    editFields,
    setEditFields,
  } = useCartDetails();

  return (
    <Cart
      className={`cart-information-resume ${
        blockUserInteraction ? "blocked" : ""
      }`}
    >
      <div className="tabs">
        <Button
          classButton={tab === "cart" ? "active" : ""}
          onClick={() => setTab("cart")}
        >
          Carrinho
        </Button>
        <Button
          classButton={tab === "info" ? "active" : ""}
          onClick={() => setTab("info")}
        >
          Dados
        </Button>
      </div>

      <div className="cart-details-container">
        {tab === "cart" && <CartSummary />}

        {tab === "info" && (
          <FormikProvider value={formik}>
            <InfoDetails
              editFields={editFields}
              setEditFields={setEditFields}
            />
          </FormikProvider>
        )}
      </div>

      {items.length > 0 && (
        <Box className="cart-buttons">
          <Button
            onClick={handleSubmit}
            loading={loading}
            disabled={blockUserInteraction}
          >
            Converter em orçamento
          </Button>
          <Button
            outlined
            onClick={handleCancelPreBudget}
            loading={loading}
            disabled={blockUserInteraction}
          >
            Cancelar pré-orçamento
          </Button>
        </Box>
      )}

      <Modal
        closeOverlay
        isOpen={cancelModal}
        requestClose={() => setCancelModal(false)}
        modalIcon={Attention}
        renderHeading={() => (
          <h2 className="text-center">
            Ao prosseguir com o cancelamento a ação não poderá ser desfeita!
          </h2>
        )}
        renderDescription={() => (
          <Box>
            <h2 className="text-center">Deseja continuar ?</h2>
          </Box>
        )}
        renderActions={() => (
          <Box display="flex" justify="center">
            <Button onClick={onCancelBudget}>Continuar</Button>
            <Button outlined onClick={() => setCancelModal(false)}>
              Voltar
            </Button>
          </Box>
        )}
      />
    </Cart>
  );
};
